import { Component, inject, Input } from '@angular/core';
import { FormGroup, FormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { ProductCategory } from '../products.model';
import { ProductsService } from '../products.service';


@Component({
  selector: 'app-department-modal',
  imports: [FormsModule, ReactiveFormsModule],
  templateUrl: './department-modal.component.html',
  styleUrl: './department-modal.component.scss'
})
export class DepartmentModalComponent {

  @Input() departments: any[] = [];
  editingDepartment: any | null = null;

  departmentForm: FormGroup;
  private fb = inject(FormBuilder);
  private productService = inject(ProductsService);
  private toastr = inject(ToastrService);
  public activeModal = inject(NgbActiveModal);

  constructor() {
    this.departmentForm = this.fb.group({
      name: [''],
      description: ['']
    });
  }

  ngOnInit(): void {}

  editDepartment(department: any) {
    this.editingDepartment = department;
    this.departmentForm.patchValue({
      name: department.name,
      description: department.description,
    });
  }

  saveCategory() {
    if (this.departmentForm.invalid) {
      this.departmentForm.markAllAsTouched();
      return;
    }
    if (this.editingDepartment) {
      this.productService.updateCategory(this.editingDepartment.id, this.departmentForm.value).subscribe({
        next: (res: ProductCategory) => {
          const idx = this.departments.findIndex(c => c.id === res.id);
          if (idx > -1) {
            this.departments[idx] = res;
          }
          this.toastr.success('Category updated');
          this.editingDepartment = null;
          this.departmentForm.reset();
        },
        error: () => this.toastr.error('Update failed')
      });
    } else {
      this.productService.addDepartment(this.departmentForm.value).subscribe({
        next: (res: any) => {
          this.toastr.success('Department saved');
          this.activeModal.close(res);
        },
        error: () => this.toastr.error('Save failed')
      });
    }
  }
}
